import _ from 'lodash';

export function flattenProjection(projection) {
    return projection.map((path) =>
        _.reduce(
            path.split('.'),
            (acc, step) => {
                if (step === '_parent_') return _.dropRight(acc);
                else return [...acc, step];
            },
            [],
        ).join('.'),
    );
}
